<!-- 营业执照 -->
<template>
    <div v-if="componentsData.type == 9"
        :style="`padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};`"
    >
        <div
            :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
        >
            <div
                :style="
                    componentsData.content.height_id == 1
                        ? 'height: 375px;'
                        : componentsData.content.height_id == 2
                        ? 'height: 187.5px;'
                        : componentsData.content.height_id == 3
                        ? 'height: 281.25px;'
                        : componentsData.content.height_id == 4
                        ? 'height: 500px;'
                        : componentsData.content.height_id == 5
                        ? 'height: 750px;'
                        : 'height: 375px;'
                "
            >
                <img class="w100" v-if="companyData.show_license" :src="companyData.show_license"
                    :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
                />
                <div class="none-div" v-else>请上传营业执照</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        companyData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.w100 {
    width: 100%;
    height: 100%;
}
.none-div {
    font-size: 14px;
    color: #808080;
}
</style>